export const CHANGE_TOPIC = 'CHANGE_TOPIC'

export function changeTopic (topic) {
  return {
    type: CHANGE_TOPIC,
    topic
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/topicActions.js